<div class="block-schedule__top">
    <ridango-ui-back-button>
        <a [routerLink]="'/schedule' | localize">{{ 'LOCAL_BTN_BACK' | translate }}</a>
    </ridango-ui-back-button>
    <h1>{{ 'SCHEDULE_SEARCH_TITLE' | translate }}</h1>
    <p>{{ 'SCHEDULE_SEARCH_DESCRIPTION' | translate }}</p>
</div>

<div class="block-tab-link-items">
    <a [routerLink]="'/schedule/search' | localize" aria-current="page"
    class="block-tab-link-items--active flex-center btn btn--maximal btn--remove-radius btn--remove-shadows
        btn--big link--no-line link--no-hover"> {{ 'SCHEDULE_SEARCH_LINK' | translate }}</a>
    <a [routerLink]="'/schedule/routes' | localize" aria-current="page"
        class="flex-center btn btn--maximal btn--remove-radius btn--big btn--remove-shadows link--no-line link--no-hover">
        {{ 'SCHEDULE_SCHEDULE_LINK' | translate }}</a>
</div>

<div class="block-schedule__bottom">
    <ridango-form-field class="form-margin-20">
        <input class="text-input" ridangoInput (keyup)="changed($event)" autocomplete="off">
        <ridango-label>{{ 'SCHEDULE_SEARCH_LINK' | translate }}</ridango-label>
    </ridango-form-field>

    <ul class="remove-bullets route-list" role="menu" *ngIf="searchResults.length > 0">
        <li *ngFor="let id of searchResults" role="none">
            <a [routerLink]="['/schedule/routes', id, 'directions']  | localize" role="menuitem"
                class="link link--no-line link--no-hover flex-center full-width min-height-60"
                (keydown)="setFocusOnNextItem($event, searchResults.length)" (click)="setPrevious(id)" #listItem>
                <span role="text" attr.aria-label="Bus {{ (allRoutes$ | async)[id].route_short_name }}"
                    class="flex-center route-list--number">
                    {{ (allRoutes$ | async)[id].route_short_name }}
                </span>
                <div class="flex flex1 position-relative min-height-50 padding-10">
                    <span class="flex1 margin-right-10 align-self-center" role="text">
                        {{ (allRoutes$ | async)[id].route_long_name }}
                    </span>
                    <span class="icon icon-arrow-right-link align-self-center"></span>
                    <div class="route-list--hr"></div>
                </div>
            </a>
        </li>
    </ul>

    <ng-container *ngIf="hasNoResult">
        <p>{{ 'SCHEDULE_SEARCH_NO_RESULTS' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="searchResults.length === 0">
        <h3>{{ 'SCHEDULE_SEARCH_PREVIOUS_SEARCH' | translate }}</h3>

        <ul class="remove-bullets route-list" role="menu" *ngIf="previousSearch.length > 0">
            <li *ngFor="let id of previousSearch" role="none">
                <a [routerLink]="['/schedule/routes', id, 'directions']  | localize" role="menuitem"
                    class="link link--no-line link--no-hover flex-center full-width min-height-60"
                    (keydown)="setFocusOnNextItem($event, previousSearch.length)"
                    (click)="setPrevious(id)" #listItem>
                    <span role="text" attr.aria-label="Bus {{ (allRoutes$ | async)[id].route_short_name }}"
                        class="flex-center route-list--number">
                        {{ (allRoutes$ | async)[id].route_short_name }}
                    </span>
                    <div class="flex flex1 position-relative min-height-50 padding-10">
                        <span class="flex1 margin-right-10 align-self-center" role="text">
                            {{ (allRoutes$ | async)[id].route_long_name }}
                        </span>
                        <span class="icon icon-arrow-right-link align-self-center"></span>
                        <div class="route-list--hr"></div>
                    </div>
                </a>
            </li>
        </ul>
    </ng-container>
</div>
